import React from "react";
import RichText from "components/rich-text";
import clsx from "clsx/lite";

const iFrame = ({ data, className }) => (
	<div className="w-full flex justify-center">
		<div className="w-fit flex flex-col justify-center items-center pb-5">
			<div className="w-full m-auto">
				{data?.content && <RichText data={{ content: data.content }} />}
			</div>
			<div className="w-full mt-5">
				<iframe src={data.src} className={clsx(className, "mx-auto")} width="100%" height="850px" />
			</div>
		</div>
	</div>
);

export default iFrame;